import React, { useContext, useEffect, useRef, useState } from 'react';
import { useCreateResponseTask } from 'services/task/mutations';
import { Button } from 'components/Atoms/Buttons';
import coinPng from 'assets/images/coin-shadow.png';
import ModalEndSubmit from 'components/Organisms/Modals/ModalEndSubmit/ModalEndSubmit';
import { Task, TaskResponse, TaskState } from '../../../../../../gql/graphql';
import { TaskContext } from '../EntityDocs';

interface Props {
  ein: TaskResponse | undefined;
  agreement: TaskResponse | undefined;
  certificate: TaskResponse | undefined;
  goodStanding: TaskResponse | undefined;
  buttonLabel: string;
  closeTask: any;
  listFileUpload: any;
  isModalEdit: boolean;
  setModalEdit: any;
  buttonShow: boolean;
  isConfirmDocs: boolean;
}
const ButtonConfirmDoc = ({
  isModalEdit,
  setModalEdit,
  buttonLabel,
  buttonShow,
  ein,
  agreement,
  certificate,
  goodStanding,
  closeTask,
  listFileUpload,
  isConfirmDocs
}: Props) => {
  const task: Task | any = useContext(TaskContext);
  const submittedRef = useRef(false);
  const [submitted, setSubmitted] = useState(false);

  const {
    data: newResponseTask,
    fetching,
    execute: createResponseTask
  } = useCreateResponseTask();

  useEffect(() => { 
    let inReviews = [
      ein,
      certificate,
      agreement,
      goodStanding
    ].filter((item) => item?.state === TaskState.Review);
    
    if (inReviews.length === 3) setModalEdit(true);
  }, [newResponseTask]);

  const confirm = () => {
    if (submittedRef.current) return;
    submittedRef.current = true;
    setSubmitted(true);
    createOrUpdateResponse('EIN letter', 'ein-letter', ein);
    createOrUpdateResponse('Operating Agreement', 'operating-agreement', agreement);
  };

  const createOrUpdateResponse = (label: string, key: string, state: any) => {
    let payload: any = {
      key,
      label,
      step: 2,
      metadata: isConfirmDocs? { viewConfirm: true }: {},
      state: TaskState.Review,
      task: task._id,
    };
    if (state) payload._id = state._id;

    const stateKey = key === 'ein-letter' ? 'ein' : key === 'operating-agreement' ? 'operating' : key;
    
    if (listFileUpload[stateKey]?.length > 0 && !listFileUpload[stateKey][0]?.state)
      payload.files = listFileUpload[stateKey];
    else 
      payload.filesExist = state?.files?.map((item: any) => ({ ...item, state: 'review' }));
    
    createResponseTask(payload);
  }

  const hasFiles = (documentKey: string, response: TaskResponse | undefined) => {
    const stateKey = documentKey === 'ein-letter' ? 'ein' : documentKey === 'operating-agreement' ? 'operating' : documentKey;
    const hasNewFiles = listFileUpload[stateKey] && listFileUpload[stateKey].length > 0;
    const hasExistingFiles = response?.files && response.files.length > 0;

    return hasNewFiles || hasExistingFiles;
  };

  const isButtonDisabled = () => {
    const hasEinFiles = hasFiles('ein-letter', ein);
    const hasOperatingFiles = hasFiles('operating-agreement', agreement);
    return !hasEinFiles || !hasOperatingFiles || fetching || submitted;
  };

  return (
    <>
      {buttonShow && (
        <Button.Primary
          className="button button-submit"
          onClick={confirm}
          disabled={isButtonDisabled()}
        >
          {buttonLabel}
        </Button.Primary>
      )}
      <ModalEndSubmit
        visible={isModalEdit}
        setVisible={setModalEdit}
        buttonAction={{
          label: buttonLabel,
          loading: fetching,
          className: 'button-submit',
          hidden: true
        }}
        modal={{
          title: `Your entity details are confirmed`,
          description: (
            <h4 className="h4 h4-w4">
              You just completed one of the tasks required to get you approved
              for your loan
            </h4>
          )
        }}
        className=""
        icon={coinPng}
        buttonSubmit={
          <Button.Primary
            className="button button-modal-ok"
            onClick={() => {
              closeTask();
              setModalEdit(false);
            }}
          >
            Go to next task
          </Button.Primary>
        }
        buttonCancel={
          <Button.Primary
            className="button button-modal-cancel"
            onClick={() => {
              closeTask();
              setModalEdit(false);
            }}
          >
            Back to dashboard
          </Button.Primary>
        }
      />
    </>
  );
};
export default ButtonConfirmDoc;
